import axios from 'axios';

export const subscriptionApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-subscriptions`,
});